import { FC, RefObject, useCallback, useEffect, useRef, useState } from "react";
import Row from "../row";
import { ScrollRowProps } from "./types";
import { JustifyContent, Wrap } from "../types";
import { useResize } from "../../../hooks";

const ScrollRow: FC<ScrollRowProps> = (props) => {
  const ref: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(window.innerWidth);

  const handleScroll = useCallback(() => {
    if (!ref.current) return;
    ref.current.style.width = window.getComputedStyle(
      ref.current.parentElement || ref.current
    ).width;
    Array.from(ref.current.children).forEach(
      (c) =>
        ((c as HTMLDivElement).style.minWidth = (
          c as HTMLDivElement
        ).style.width)
    );
    ref.current.style.flexFlow = props.reverse ? "row-reverse" : "row";
    ref.current.style.overflowX = "scroll";
    ref.current.style.height = props.height ? `${props.height}px` : "auto";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.height, ref, props.reverse, props.children]);

  useEffect(() => {
    setTimeout(handleScroll, 50);
  }, [handleScroll]);

  useResize(handleScroll);

  useResize(
    useCallback(() => {
      if (!ref.current) return;
      if (window.innerWidth < width) {
        const widthStr = window.getComputedStyle(
          ref.current.parentElement || ref.current
        ).width;
        const widthNumber = Number(widthStr.substring(0, widthStr.length - 2));
        ref.current.style.width = `${
          widthNumber - (width - window.innerWidth)
        }px`;
      }
      setWidth(window.innerWidth);
    }, [width, ref])
  );

  return (
    <Row
      {...props}
      containerRef={ref}
      flexWrap={Wrap.Wrap}
      justifyContent={JustifyContent.Start}
    >
      {props.children}
    </Row>
  );
};

export default ScrollRow;
